module.exports = __webpack_public_path__ + "img/charts-icon.ddfbd0e3.png";